export default {
  "pt-BR": {
    stageList: {
      data: "Dados Cadastrais",
      test: "Teste",
      trainner: "Treinamento",
      assay: "Análise",
      medic: "Exame Médico",
      preAdmition: "Pré admissão",
      admition: "Admissão",
      ambietation: "Ambientação",
      feedback: "FeedBack",
      contract: "Contrato",
      table: {
        kindTest: "TIPO DE TESTE",
        kind: "TIPO",
        nameTest: "NOME DO TESTE",
        level: "NÍVEL",
        avaliation: "AVALIAÇÃO",
        questionsTime: "TEMPO DO TESTE",
        title: "TÍTULO",
        name: "NOME",
        amountOfQuestions: "QUANT PERGUNTAS",
      },
    },
    question: {
      typeSelect: "Tipo de resposta",
      selectCorrectAnsewr: "Selecione a resposta correta",
      correctAnsewr: "Resposta correta",
      mandatory: "Obrigatória",
    },
    testForm: {
      breadCrumb: "Nova etapa de teste",
      newTeste: "Nova etapa de teste",
    },
    defaultStage: {
      stagesNames: {
        trainner: "Nova treinamento",
        test: "Novo Teste",
        assay: "Nova Análise",
        medicExame: "Novo Exame Médico",
        admition: "Nova Admissão",
        ambietation: "Nova Ambientação",
        feedBack: "Novo FeedBack",
        newEstage: "Nova Etapa",
        preAdmition: "Pré admissão",
        contract: "Novo contrato"
      }
    },
    newStageAboutYou: {
      items: {
        default:
          "Este Bloco contem perguntas de carater pessoal e informativo. Busca saber dados pessoais e conhecer um pouco sobre a pessoa, suas habilidades, aspirações, conhecimentos, qualidades e defeitos.",
      },
      breadCrumb: "Dados cadastrais",
      trash: "VOLTAR",
      associationJob: "ASSOCIAR CARGO",
      edit: "EDITAR",
      stagesTitle: {
        default: "Dados básicos",
        aboutYou: "Sobre você",
        carrier: "Carreira",
        formation: "Formação",
        goal: "Objetivos",
      },
      dialog: {
        question: "Excluir esta etapa ?",
        questionConfirmation: "Tem certeza que deseja excluir esta etapa?",
      },
      mandatory: "Todos os cargos",
    },
    inputs: {
      affiliate: "Coligada",
      resultCenter: "Centro de resultado",
      section: "Seção",
      taker: "Tomador",
      managerCode: "Matrícula do gestor",
      managerName: "Nome do gestor",
      area: "Área",
      job: "Cargo",
      vacancyCode: "Código da vaga",
      howManyVacancy: "Quantidade de vagas",
      journey: "Jornada",
      periode: "Horário",
      periodeRealization: "Periodo de realização",
      periodeAvaliation: "Periodo de avaliação",
      placeOfWork: "Local de trabalho",
      description: "Descrição da vaga",
      salary: "Salário",
      startWork: "Início das atividades",
      temporariVacancy: "Vaga Temporária",
      schooling: "Escolaridade",
      areaFormation: "Área de formação",
      tecnicKnowledge: "Conhecimento técnico",
      competence: "Competências",
      disabledPerson: "Aceitar pessoas com deficiência",
      timeOfWork: "Tempo de empresa (mês)",
      lastPromotion: "Última promoção (mês)",
      city: "Cidades elegíveis",
      eligibleJobs: "Cargos elegíveis",
      selectAllJobs: "Selecionar todos",
      areaOfWork: "Local de trabalho",
      funcCode: "Matrícula do colaborador",
      funcName: "Nome do colaborador",
      sector: "Setor",
      selectArea: "Selecione a área",
      autoCorrect: "Correção automática",
      aprovation: "Aprovação",
      time: "Tempo",
      weight: "Peso",
      kindAnserw: "Tipo de resposta",
      multSelect: "Multi-select",
      uniqSelect: "Seleção única",
      number: "Numérico",
      date: "Data",
      text: "Texto",
      redaction: "Redação",
      startHour: "Hora Inicial",
      endHour: "Hora final",
      placeOfInterview: "Local da entrevista",
      placeOfExam: "Local do exame",
      responsibility: "Responsabilidades",
      titleVaga: "Título da vaga",
      informeSalary: "Informar faixa salarial",
      confidentialVacancy: "Vaga confidencial",
      showSalary: "Exibir salário no portal",
      informeSchedules: "Informar faixa de horário",
      aboutWork: "Sobre o trabalho",
      skills: "Habilidades",
      benefits: "Benefícios",
      experiences: "Experiencias",
      deficiency: "Necessidade especiais",
      vacancyReq: "Requisitos da vaga",
      select: "Selecione...",
      jobAndArea: "Cargo ou área",
      vacancyGroup: "Agrupar vaga(Opcional)",
      numberSMP: "Número SMP",
      note: "Observações"
    },
    login: {
      buttonLogin: "Entrar",
      reset: "Redefinir",
      password: "Senha",
      forgotPassword: "Esqueci minha senha.",
      back: "Voltar",
      disclaimerForgot:
        "Insira seu endereço de e-mail que lhe enviaremos um link de redefinição de senha",
      newPassword: {
        password: "Senha Atual",
        rePassword: "Recadastrar senha",
        newPassword: "Digite sua nova senha",
        confirmPassword: "Confirme sua nova senha",
        formatPassword:
          "A senha deve ter no minimo 8 caracteres, letra maiscula e miniscula , números e caractere especial",
      },
    },
    homeOptions: {
      logout: "Fazer logout",
      welcome: "Bem-Vindo",
      talentsModule: "Talentos",
      choiceModule: "Insert",
      trainnerModule: "AeC Trainner",
      managerModule: "Configurações",
      changePassword: "Trocar senha",
    },
    menuTalentBar: {
      dashboard: "Dashboard",
      start: "Inicial",
      vacancy: "Vagas",
      stage: "Etapas",
      candidates: "Candidatos",
      rails: "Trilhas",
      selectVacancy: "Selecione a vaga",
      selectCandidate: "Selecione o candidato",
      managers: "Administradores",
    },
    vacancyList: {
      trail: "Trilha",
      stop: "Paralisar",
      statusEnabledVacancy: "Dentro do Prazo",
      statuswaitingVacancy: "Próximo ao vencimento",
      statusCanceledVacancy: "Fora do prazo",
      draft: "Não Publicadas",
      open: "Publicadas",
      inProgress: "Em Andamento",
      newVacancy: "Nova Vaga",
      editVacancy: "Editar Vaga",
      finished: "Finalizadas",
      columns: {
        code: "Código",
        vacancy: "VAGA",
        selection: "SELEÇÃO",
        createdBy: "CRIADO POR",
        createdAt: "CRIADO EM",
        site: "SITE",
        owner: "Responsavel",
        role: "Cargo",
        area: "ÁREA",
        manager: "Gestor",
        noInformation: "Não informado",
        mandatory: "Obrigatario",
        actions: "AÇÕES",
        job: "CARGO",
        current: "ETAPA",
        result: "RESULTADO",
        applyAt: "APLICOU EM",
        status: "STATUS",
        name: "NOME",
        cpf: "CPF",
        enrollment: "MATRÍCULA",
        scheduling: "AGENDAMENTO",
        scheduleTime: "AGENDAMENTO",
        locality: "LOCAL",
        note: "OBSERVAÇÃO"
      }
    },
    vacancyCreate: {
      createVacancy: "Cadastro de nova vaga",
      editVacancy: "Editando vaga",
      useBankOfTalents: "Utilizar banco de talentos?",
      actionCandidate: "Selecione a ação:",
      sharedDisclaimer:
        "Utilize uma das opções abaixo para compartilhar a vaga criada.",
      linkVacancy: "link da vaga",
      socialMedia: "Mídias sociais:",
      sharedVacancy: "Divulgação da vaga",
      questionBankOfTalents:
        "Utilizando ele, o sistema Talentos AeC verificará se existem pessoas que se enquadram na oportunidade para aplicação.",
      yesDiv: "Sim, e divulgar as oportunidades.",
      noDiv: "Sim, e não divulgar.",
      fields: {
        typeForm: {
          internal: "Interna",
          external: "Externa",
        },
        kindVaga: {
          bdTalents: "Banco de talentos",
          existentVacancy: "Vaga existente",
          promotion: "Promoção",
        },
      },
    },
    NewCandidatesVacancy: {
      addCandidate: "Adicionar candidato na vaga",
      title:
        "Após validação da exceção, informe os dados do candidato para inclui-lo na vaga. Atenção: Ao prosseguir com essa ação, você estará confirmando a inclusão de um candidato sem passar pelos filtros de elegibilidade no sistema, conforme procedimento padrão. ",
      type: "Realizar inclusão por:",
      CPF: "CPF",
      matricula: "Matricula",
      justification:
        "Justificativa (Informe abaixo o motivo da exceção para inclusão do candidato na vaga)",
      add: "Adicionar",
    },
    vacancyShow: {
      statusApprove: "Aprovado",
      declined: "Reprovados",
      declinedCandidate: "Vaga  |  Reprovado",
      approvedCandidate: "Aprovado",
      statusFinished: "Finalizado",
      statusInProgress: "Etapas Em Andamento",
      hired: "Contratado / Promovido",
      schedules: "Etapa | Agendamentos",
      inBankOfTalent: "Banco de talentos",
      removed: "Removido da Vaga",
      addCandidate: "Adicionar candidatos",
      trackStage: "Etapa atual da Trilha:",
      changeTime: "Troca de horários",
      showTrack: "VER TRILHA",
      tableStatus: {
        statusCandidate: "Candidato",
        statusApprove: "aprovado",
        statusDecline: "reprovado",
      },
    },
    bankOfTalents: {
      currentBanckOfTalent: "Vigentes",
      removed: "Removidos",
      declinedCandidate: "Reprovado",
      approvedCandidate: "Aprovado",
      statusFinished: "Finalizado",
      statusInProgress: "Em andamento",
      inBankOfTalent: "Banco de talentos",
      addCandidate: "Adicionar candidatos",
      trackStage: "Etapa atual da Trilha:",
      changeTime: "Troca de horários",
      showTrack: "VER TRILHA",
      tableStatus: {
        statusCandidate: "Candidato",
        statusApprove: "aprovado",
        statusDecline: "reprovado",
      },
      columns: {
        cargo: "Cargo",
        site: "Site",
        typevacancy: "Tipo vaga",
        idvacancy: "Id vaga",
        responsible: "Responsavel",
        dateinclusion: "Data de inclusão",
        daysinbank: "Dias no banco",
        vencimento: "Vencimento",
        cpf: "CPF",
        name: "Nome",
        chapa: "Chapa",
        reasonnottopromote: "Motivo não promoção",
        robbyson: "Robbyson",
      },
    },
    schedule: {
      addTimer: "Adicionar outra faixa",
      amountOfVacancies: "Quantidade de vagas da faixa",
      startHour: "Início do expediente",
      endHour: "Fim do expediente",
    },
    manager: {
      perfis: "Perfis",
      administradores: "Usuários",
      btnincluirperfil: "Incluir",
      podeeditaretapas: "Pode editar etapas",
      permissoesperfil: "Permissões do Perfil : ",
      permissaosite: "Limite por site",
      cadastroperfil: "Lista de Perfis",
      nomeprofile: "Nome do perfil",
      id: " ID",
      habilitar: "Habilitar",
      site: "Site",
      nomeAdmin: "Nome",
      Perfil: "Perfil",
      unidade: "Unidade",
      unidades: "Permissões por Unidade",
      autorizado: "Autorizado",
      profilesector: "Permissão por seção",
      createUser: "Criar usuário",
      newUser: "Cadastro de novo usuário",
      registrationNumber: "Matricula",
      search: "Buscar",
      name: "Nome",
      email: "E-mail",
      createUser: "Novo Usuário",
      IsAdministrator: "Pode acessar configuração",
      canAcessPlug: "Pode acessar Plug",
      canAcessTalentos: "Pode acessar Talentos",
      deletar: "Deletar",
      acessoPlug: "Acesso ao Plug",
      acessoTalentos: "Acesso ao Talentos",
      actions: "Ações",
      administrator: "Acesso a configuração",
      realmenteDesejaDeletar: "Realmente deseja deletar?",
    },
    sharedItems: {
      days: "Dias",
      question: "Pergunta",
      back: "VOLTAR",
      bankoftalets: "ENVIAR BANCO TALENTOS",
      hire: "CONTRATAR / PROMOVER",
      add: "ADICIONAR",
      disabled: "desativar",
      enable: "ativar",
      email: "E-mail",
      levelTest: "Nivel do teste",
      save: "SALVAR",
      publishVacancy: "PUBLICAR VAGA",
      publishVacancyBanner: "Publicação da vaga",
      shareVacancy: "COMPARTILHAR",
      selectImage:
        "Selecione uma imagem que represente o perfil de candidato para a vaga:",
      affiliateRails: "ASSOCIAR TRILHA",
      viewRails: "Visualizar trilha",
      affiliateRailsDown: "Associar trilha",
      stats: "Status",
      name: "Nome",
      level: "Nível",
      job: "Cargo",
      indicator: "Indicador",
      kind: "Tipo",
      description: "Descrição",
      time: "Horário",
      confirme: "Confirmar",
      edit: "SALVAR EDIÇÃO",
      cancel: "CANCELAR",
      next: "PRÓXIMO",
      kindTest: "Tipo de teste",
      kindTrainner: "Tipo de treinamento",
      remove: "remover",
      view: "Visualizar",
      viewEdit: "Alterar Status",
      search: "Buscar",
      selection: "Seleção",
      vacancy: "Vaga",
      formEspecificInformation: "Informações específicas",
      formVacancyInformation: "Informações da vaga",
      formSelectionInformation: "Informações de seleção",
      formCandidate: "Características do candidato",
      formTimeOfWork: "Faixa de horário de trabalho",
      formInternal: "Informações internas",
      performanceIndicator: "Indicador de Performance",
      addIndicator: "ADICIONAR INDICADOR",
      avaliation: "Avaliação",
      timeTest: "Tempo para o teste",
      candidateForVacancy: "Candidato para a  vaga:",
      mediumQuestionTime: "Tempo médio por pergunta",
      addQuestion: "Adicionar pergunta",
      yes: "Sim",
      no: "Não",
      useRails: "USAR TRILHA",
      editRails: "EDITAR TRILHA",
      at: "Em",
      createdBy: "Criado por",
      close: "FECHAR",
      until: "até",
      delete: "deletar",
      removeQuestionTitle: "Remover Pergunta",
      removeQuestion: "Deseja remover esta pergunta ?",
      openVacancy: "Aberta",
      closeVacancy: "Fechada",
      filter: "Filtrar",
      registers: "Registros",
      code: "Código:",
      enrollment: "Matrícula",
      periode: "Período",
      manager: "Gestor:",
      status: "Status",
      clear: "Limpar",
      clearUper: "LIMPAR",
      apply: "Aplicar",
      site: "Site",
      applyedCandidates: "Candidatos aplicados",
      openVagas: "Número de vagas disponível",
      stage: "Etapa atual",
      historic: "Histórico",
      sendMessage: "Enviar mensagem",
      jobCandidate: "Candidato para cargo:",
      area: "Área:",
      managerInfo: "Gestor:",
      candidateStage: "Etapa do candidato:",
      confirmApprove: "Confirmar aprovação",
      bankofTalents: "Banco de talentos",
      hire: "Contratar / Promover",

      declineApprove: "Confirmar reprovação",
      pendingApprove: "Confirmar pendência",

      confirmRemoval: "Confirmar remoção",

      keep: "Continuar",
      nameRole: "Cargo",
      nivel: "Nível",
      months: "Mês",
      stagesTitle: {
        default: "Dados básicos",
        aboutYou: "Sobre você",
        carrier: "Carreira",
        formation: "Formação",
        goal: "Objetivos",
        test: "Teste",
      },
      about: "Sobre",
      carrier: "Carreira",
      formation: "Formação",
      goal: "Objetivos",
      attach: "Anexos",
      CPF: "CPF",
      RG: "RG",
      birth: "Nascimento",
      phone: "Telefone",
      nationality: "Nacionalidade",
      state: "Estado",
      city: "Cidade",
      neighborhood: "Bairro",
      street: "Logradouro",
      Complement: "Complemento",
      zipCode: "CEP",
      sendFeedBack: "Enviar feedback ...",
      enableCandidateAnswer: "Habilitar resposta do(s) candidato(s).",
      dateOfTest: "Data de realização",
      result: "Resultado",
      minimumResult: "Resultado Mínimo",
      evaluate: "Avaliar",
      evaluateApproved: "Aprovado",
      evaluateReproved: "Reprovado",
      evaluateCurrent: "Atual",
      evaluateportfolio: "Avaliar portfolio",
      evaluatewait: "Aguardando",
      manualEvaluatewait: "Aprovação manual",
      evalueteTest: "Visualizar teste",
      applyToAllSameTime:
        "Aplicar as mesmas datas e horários para todos os canditos",
      interviewCandidates: "Entrevistar candidatos",
      medicExame: "Marcar exame médico",
      icsFile: "BAIXAR .ICS",
      scheduleCandidates: "Agendar candidatos",
      selectVacancy: "Selecione a vaga",
      selectCandidate: "Selecione o candidato",
      generatePreview: "Visualizar preview",
      confirmPublication: "Deseja confirmar a publicação dessa vaga ?",
      confirmDeleteVacancy: "Deseja cancelar essa vaga?",
      deleteVacancy: "Cancelar vaga",
      createQuestions: "Criar perguntas",
      finish: "Finalizar",
      applyAt: "Aplicou em",
      startDate: "Data Inicial",
      endDate: "Data Final",
      startDateApplied: "Data Inicial - APLICOU EM",
      endDateApplied: "Data Final - APLICOU EM",
      schedulingDate: "Data Agendamento",
      pending: "Pendenciar",
      empty: "",
      showfeedback: "Este feedback será exibido para o(s) candidato(s)",
      notFeedback: "Este feedback não será exibido para o(s) candidato(s)",
      selectStage: "Selecione a etapa",
      selectAction: "Selecione a ação",
      exportCandidate: "Exportar",
      actualRail: "Trilha atual",
      clearFilter: "Limpar Filtro",
      loadMore: "Carregar Mais",
    },
    rails: {
      title: "Lista de Trilhas",
      newRails: "Nova trilha",
      addStageTorails: "ADICIONAR NOVA ETAPA",
      addStageTorailsList: "Adicionar  etapa",
      searchStage: "Buscar etapa",
      kindStage: "Tipo de etapa",
      kindTest: "Tipo de teste",
      levelTest: "Nível do teste",
      timeToTest: "Tempo para teste",
      spendTimeInTest: "Tempo gasto",
      timeToQuetionTest: "Perguntas / Tempo médio",
      level: "Nível",
      avaliation: "Avaliação",
      numberOfQuestion: "Nº de perguntas",
      maxTime: "Tempo máximo",
      assayKind: "Tipo de análise",
      trainnerKind: "Tipo de treinamento",
      exameKind: "Tipo de exame",
      ambientationKind: "Tipo de ambientação",
      test: "Teste",
      medic: "Exame médico",
      trainner: "Treinamento",
      assay: "Análise",
      admition: "Admissão",
      ambientation: "Ambientação",
      feedBack: "FeedBack",
      questions: "Tempo do teste",
      existiRails: "Já existem trilhas para o cargo",
      noRails: "Não existem trilhas para o cargo",
      stageDetails: "Detalhes da etapa",
      desableRails: "Deseja alterar o status dessa trilha ?",
      associationVacancy: "Associar trilha",
      preAdmition: "Pré admissão",
      analyze: "Análise",
      editRails: "Editar trilha",
    },
    menuPlugBar: {
      dashboard: "Dashboard",
      start: "Inicial",
      documents: "Documentação",
      contracts: "Contratos",
      stage: "Etapas",
      candidates: "Candidatos",
      rails: "Trilhas",
      selectVacancy: "Selecione a vaga",
      selectCandidate: "Selecione o candidato",
      managers: "Administradores",
      doubts:"Dúvidas"
    },
    menuManagerBar: {
      users: "Usuários",
      modules: "Módulos",
      profiles: "Perfis",
      settings: "Cadastros",
      parameters: "Parametros"
    },
    menuBankOfTalentsBar: {
      users: "Usuários",
      BankOfTalents: "Banco de Talentos",
    },
    duvidasCandidate:{
      nomeCandidato: "Nome",
      motivoDoContato:"Motivo do contato",
      status: "Status",
      descricao:"Descrição",
      dataDoChamado: "Data abertura",
      detalhes:"DETALHES",
      responder:"Responder"
    },
    duvidasCandidateList:{
      nomeCandidato: "Nome",
      motivoDoContato:"Motivo do contato",
      status: "Status",
      descricao:"Descrição",
      dataDoChamado: "Data",
    },
    documentsCandidateList: {
      vaga: "Vaga",
      cpf: "CPF",
      filterCpf: "CPF",
      filterIdVaga: "Código da vaga",
      filterLocation: "Local trabalho",
      nomeCandidato: "Nome",
      dataAdmissaoPrevista: "Admissão",
      dataDoChamado:"Aberto",
      motivoDoContato:"Motivo do contato",
      documentosEnviados: "Documentos Enviados",
      status: "Status",
      analisar: "Analisar",
      draft: "Rascunhos",
      visualizar:"Visualizar dúvida",
      open: "Abertas",
      newVacancy: "Nova Vaga",
      editVacancy: "Editar Vaga",
      finished: "Finalizadas",
      documents: "Documentos",
      columns: {
        code: "Código",
        vacancy: "VAGA",
        selection: "SELEÇÃO",
        createdBy: "CRIADO POR",
        createdAt: "CRIADO EM",
        role: "Cargo",
        idDocument: "ID",
        typeDocument: "Tipo Documento",
        document: "Documento",
        status: "Status",
        action: "Ação",
        area: "ÁREA",
        manager: "Gestor",
        noInformation: "Não informado",
        mandatory: "Obrigatario",
        actions: "AÇÕES",
        job: "CARGO",
        current: "ETAPA",
        result: "RESULTADO",
        applyAt: "APLICOU EM",
        status: "STATUS",
        name: "NOME",
      },
    },
    bankOfTalents: {
      admin: "Responsavel",
      job: "Cargo"
    },

    contracts: {
      confirmSendKitMessage: "Confirmar Kit",
      confirmSendMessage: "Confirmar Envio",
      sendConfirmMsgTitleKit:
        "Alteração de kit do candidato",
      sendConfirmMsgTitle:
        "Envio de mensagem de aceita para candidato",
      sendConfirmMsgDescription:
        "Digite a mensagem com as informações para o candidato",
      View_default_contract: "Contrato",
      View_assigned_contract: "Contrato assinado",
      cpf: "CPF",
      filterCpf: "CPF",
      filterIdVaga: "Código da vaga",
      filterLocation: "Local trabalho",
      statusEtapa: "Status da etapa",
      motivoDoContato:"Motivo do contato",
      nomeCandidato: "Nome",
      titleVacancy: "Vaga:",
      documentosEnviados: "Documentos Enviados",
      status: "Status",
      analisar: "Analisar",
      draft: "Rascunhos",
      open: "Abertas",
      newVacancy: "Nova Vaga",
      editVacancy: "Editar Vaga",
      finished: "Finalizadas",
      documents: "Documentos",
      columns: {
        code: "Código",
        vacancy: "VAGA",
        selection: "SELEÇÃO",
        createdBy: "CRIADO POR",
        createdAt: "CRIADO EM",
        role: "Cargo",
        idDocument: "ID",
        typeDocument: "Tipo Documento",
        document: "Documento",
        status: "Status",
        action: "Ação",
        area: "ÁREA",
        manager: "Gestor",
        noInformation: "Não informado",
        mandatory: "Obrigatario",
        actions: "AÇÕES",
        job: "CARGO",
        current: "ETAPA",
        result: "RESULTADO",
        applyAt: "APLICOU EM",
        status: "STATUS",
        name: "NOME",
      },
    },
  },
};

export const months = [
  { label: "Jan", value: 1 },
  { label: "Fev", value: 2 },
  { label: "Mar", value: 3 },
  { label: "Abr", value: 4 },
  { label: "Mai", value: 5 },
  { label: "Jun", value: 6 },
  { label: "Jul", value: 7 },
  { label: "Ago", value: 8 },
  { label: "Set", value: 9 },
  { label: "Out", value: 10 },
  { label: "Nov", value: 11 },
  { label: "Dez", value: 12 },
];

export const kindStages = [
  { name: "Dados cadastrais", id: 0, item: "data", label: "stageList.data" },
  { name: "Teste", id: 1, label: "rails.test" },
  { name: "Treinamento", id: 2, item: "trainnerKind", label: "rails.trainner" },
  { name: "Analise", id: 3, item: "assayKind", label: "rails.analyze" },
  { name: "Exame Médico", id: 4, item: "exameKind", label: "rails.medic" },
  { name: "Admissão", id: 5, label: "rails.admition" },
  {
    name: "Ambientação",
    id: 6,
    item: "ambientationKind",
    label: "rails.ambientation",
  },
  { name: "FeedBack", id: 7, label: "rails.feedBack" },
  { name: "Pré admissão", id: 8, label: "rails.preAdmition" },
  { name: "Pré admissão", id: 8, label: "rails.preAdmition" },
  {
    name: "Aprovação final",
    id: 99999999,
    item: "data",
    label: "stageList.data",
  },
];

export const StatusStages = [
  { name: "Aguardando", id: 0 },
  { name: "Em Análise", id: 1 },
  { name: "Aprovado Por Pontuacao", id: 2 },
  { name: "Aprovado Manualmente", id: 3 },
  { name: "Cancelado", id: 4 },
  { name: "Reprovado Por Pontuação", id: 5 },
  { name: "Tempo Exirado", id: 6 },
  { name: "Conexão Perdida", id: 7 },
  { name: "Reprovado Manualmente", id: 8 },
  { name: "Pronto para validação", id: 9 },
  { name: "Pendenciado", id: 10 },
  { name: "Reprovado por inelegibilidade", id: 11 },
  { name: "Concluido com pendência de processamento", id: 12 },
  { name: "Redação iniciada", id: 13 },
  { name: "Redação finalizada", id: 14 },
  { name: "Redação concluido com pendência de processamento", id: 15 },
  { name: "Contrato finalizado", id: 16 },
  { name: "Divergencia detectada pelo candidato", id: 17 },
  { name: "Desistente", id: 18 },
  { name: "RemovidoPeloRecrutador", id: 19 }
];

export const StatusVacancy = [
  { name: "Em Andamento", id: 0 },
  { name: "Aprovado", id: 1 },
  { name: "Reprovado", id: 2 },
  { name: "ContratadoPromovido", id: 4 },
  { name: "EmBancoHoras", id: 5 },
  { name: "RemovidoPeloRecrutador", id: 12 }

];

export const schedulingCandidateAction = { name: "AGENDAMENTO", id: 2 };
export const pendingCandidateAction = { name: "PENDENCIAR", id: 3 };
export const bancoTalentosCandidateAction = {
  name: "BANCO DE TALENTOS",
  id: 4,
};
export const contratarCandidateAction = { name: "CONTRATAR/PROMOVER", id: 5 };

export const candidatesActions = [
  { name: "APROVAR ETAPA", id: 0 },
  { name: "REPROVAR ETAPA", id: 1 },
  { name: "REMOVER DA VAGA", id: 6 },
];

export const candidatesRefused = [{ name: "APROVAR ETAPA", id: 0 }];
export const candidatesApproved = [
  { name: "BANCO DE TALENTOS", id: 4 },
  { name: "CONTRATAR/PROMOVER", id: 5 },
];

export const renderNumberOfSelected = (many) =>
  `Todos os candidatos ( ${many} selecionad${many > 1 ? "os" : "o"} )`;
export const questionApproveCandidate = (many) =>
  `Tem certeza que deseja aprovar os ${many} candidatos selecionados?`;
export const questionReproveCandidate = (many) =>
  `Tem certeza que deseja reprovar os ${many} candidatos selecionados?`;
export const questionPendingCandidate = (many) =>
  `Tem certeza que deseja pendenciar os ${many} candidatos selecionados?`;
export const questionRemoveCandidate = many =>
  `Tem certeza que deseja remover os ${many} candidatos selecionados?`;
export const VACANCY_OPTIONS = [
  { name: "Interna", kind: "internal" },
  { name: "Externa", kind: "external" },
  { name: "Banco de Talentos", kind: "talents" },
  { name: "Vaga Existente", kind: "existJob" },
  { name: "Promoção", kind: "promotion" },
];
